export default {
  /*
  * 缓存
  */
  storage: {
    userid: 'rongyingUserId', // 用户ID
    token: 'rongyingUserToken', // 用户token
    editSlider: 'rongyingEditSlider', // 编辑的轮播图
    editClient: 'rongyingEditClient', // 编辑的客户
    CaseClient: 'rongyingCaseClient', // 编辑的案例
    IndustryClient: 'rongyingIndustryClient', // 编辑的行业
    HonorClient: 'rongyingHonorClient', // 编辑的荣誉
    EventClient: 'rongyingEventClient', // 编辑的大事件
    BusinessClient: 'rongyingBusinessClient' // 编辑的业务
  }
}



// WEBPACK FOOTER //
// ./src/utils/config.js